<template>
  <v-img v-if="image != '' && image != null && image != undefined && image != 'no-image'" :src="image" alt="Produto" eager></v-img>
  <v-img v-else-if="image == 'no-image'" src="@/assets/images/genericproduct.jpg" alt="Produto"></v-img>
</template>

<script>
export default {
  name: 'Svg',
  props: {
    image: {
      type: String,
      default: ''
    }
  }
}
</script>